'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildChatHeadingConfig = undefined;

var _getType = require('../operators/getType');

var _buildChatHeadingConfigFromType = require('./buildChatHeadingConfigFromType');

var buildChatHeadingConfig = exports.buildChatHeadingConfig = function buildChatHeadingConfig(options) {
  var chatConfigType = (0, _getType.getType)(options);
  return (0, _buildChatHeadingConfigFromType.buildChatHeadingConfigFromType)(chatConfigType, options);
};